import { spawnSparkles } from './spawnSparkles';

// Two waves of sparkle bursts at randomised anchor points across a
// container. Reuses spawnSparkles for the DOM path so we get the same
// reduced-motion guard + WAAPI cleanup story for free.

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function prefersReducedMotion(): boolean {
  const w = globalThis.window as Window | undefined;
  if (!w || typeof w.matchMedia !== 'function') return false;
  try {
    return w.matchMedia(REDUCED_MOTION_QUERY).matches;
  } catch {
    return false;
  }
}

export interface SpawnFireworksOptions {
  waves?: number;
  perWave?: number;
  waveDelayMs?: number;
}

export function spawnFireworks(container: Element, options: SpawnFireworksOptions = {}): void {
  if (prefersReducedMotion()) return;
  const { waves = 2, perWave = 3, waveDelayMs = 350 } = options;
  const rect = container.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return;

  for (let wave = 0; wave < waves; wave++) {
    setTimeout(() => {
      for (let i = 0; i < perWave; i++) {
        const anchor = document.createElement('div');
        const x = rect.left + Math.random() * rect.width;
        const y = rect.top + Math.random() * rect.height * 0.7;
        anchor.style.cssText = `position: fixed; left: ${x}px; top: ${y}px; width: 1px; height: 1px; pointer-events: none;`;
        document.body.appendChild(anchor);
        spawnSparkles(anchor);
        // Anchor is only needed for the getBoundingClientRect read inside
        // spawnSparkles; it can be removed on the next tick.
        setTimeout(() => {
          if (anchor.isConnected) anchor.remove();
        }, 0);
      }
    }, wave * waveDelayMs);
  }
}
